
import React from 'react';
import { Shop } from '../types';
import { cn } from '@/lib/utils';
import { Settings } from 'lucide-react';

interface ShopFilterItemProps {
  shop: Shop;
  displayFull?: boolean;
  isSelected?: boolean;
  onSettingsClick?: (shopId: string) => void;
}

export const ShopFilterItem: React.FC<ShopFilterItemProps> = ({ 
  shop, 
  displayFull = false,
  isSelected = false,
  onSettingsClick
}) => {
  const displayInitial = shop.name.charAt(0).toUpperCase();
  const logoUrl = shop.logo_url;

  const handleSettingsClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    
    if (onSettingsClick) {
      onSettingsClick(shop.id);
    }
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center">
        <div className={cn(
          "w-8 h-8 flex items-center justify-center rounded-full text-sm font-medium",
          isSelected 
            ? "bg-purple-100 text-purple-800" 
            : "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300"
        )}>
          {logoUrl ? (
            <img src={logoUrl} alt={shop.name} className="w-full h-full rounded-full object-cover" />
          ) : (
            <span>{displayInitial}</span>
          )}
        </div>
        {displayFull && (
          <span className={cn(
            "ml-3 text-gray-700 dark:text-gray-300",
            isSelected && "font-medium"
          )}>
            {shop.name}
          </span>
        )}
      </div>
      
      {onSettingsClick && (
        <button
          className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 p-1 rounded-full"
          onClick={handleSettingsClick}
          aria-label={`Paramètres pour ${shop.name}`}
        >
          <Settings className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
